//Libs
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
//Componentes material
import Typography from '@material-ui/core/Typography';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core';
//Componentes
import ResultadoQuestaoTexto from './ResultadoQuestaoTexto';
import ResultadoQuestaoInteiro from './ResultadoQuestaoInteiro';
import ResultadoQuestaoNumerico from './ResultadoQuestaoNumerico';
import ResultadoQuestaoEscolha from './ResultadoQuestaoEscolha';
import ResultadoQuestaoMultiplaEscolha from './ResultadoQuestaoMultiplaEscolha';
import ResultadoQuestaoFoto from './ResultadoQuestaoFoto';
import ResultadoQuestaoGrafico from './ResultadoQuestaoGrafico';
import ResultadoQuestaoTextoFixo from './ResultadoQuestaoTextoFixo';
//Models
import AvaliacaoResposta from '../../models/AvaliacaoResposta';
import Avaliacao from '../../models/Avaliacao';
//Estilos
import ResultadoStyle from '../../styles/ResultadoStyle';
import { TIPO_ESCOLHA, TIPO_FOTO, TIPO_INTEIRO, TIPO_MULTIPLAESCOLHA, TIPO_NUMERICO, TIPO_TEXTO, TIPO_TEXTO_FIXO } from '../../models/QuestionarioQuestao';

/**
 * Renderiza os componentes para exibição da resposta de acordo com o tipo da questão
 * @param {Array<AvaliacaoResposta>} respostas Dados das respostas a serem exibidas
 * @param {Array<Avaliacao>} avaliacoes Dados das avaliacoes a serem exibidas
 * @returns {Object} Retorna o componente correspondente
 */
function renderizarRespostas(respostas, avaliacoes) {
    const tipo = respostas[0].tipo;
    if (respostas[0].exibeGrafico)
        return <ResultadoQuestaoGrafico respostas={respostas} avaliacoes={avaliacoes} />;
    else if (tipo === TIPO_TEXTO)
        return <ResultadoQuestaoTexto respostas={respostas} />;
    else if (tipo === TIPO_INTEIRO)
        return <ResultadoQuestaoInteiro respostas={respostas} />;
    else if (tipo === TIPO_NUMERICO)
        return <ResultadoQuestaoNumerico respostas={respostas} />;
    else if (tipo === TIPO_ESCOLHA)
        return <ResultadoQuestaoEscolha respostas={respostas} />;
    else if (tipo === TIPO_MULTIPLAESCOLHA)
        return <ResultadoQuestaoMultiplaEscolha respostas={respostas} />;
    else if (tipo === TIPO_FOTO)
        return <ResultadoQuestaoFoto respostas={respostas} />;
    else if (tipo === TIPO_TEXTO_FIXO)
        return <ResultadoQuestaoTextoFixo respostas={respostas} />;
}

/**
 * Verifica se as respostas devem ser impressas no resultado
 * @param {Array<AvaliacaoResposta>} respostas Dados das respostas a serem exibidas
 * @return {Boolean} Retorna verdadeiro se a resposta deve ser exibida
 */
function imprimeResposta(respostas) {
    //Para questões do tipo 'textoFixo' somente imprime as que estiverem configuradas
    if (respostas[0].tipo === TIPO_TEXTO_FIXO)
        return respostas[0].exibeResultado;
    else 
        return true;
}

/**
 * Renderiza os dados de uma questão e as respostas
 * @param {Object} props Propriedades repassadas para o componente
 * @param {Array<AvaliacaoResposta>} props.respostas Dados das respostas a serem exibidas
 * @param {Array<Avaliacao>} props.avaliacoes Dados das avaliações a serem exibidas
 * @param {Object} props.classes Classes CSS do componente
 */
function ResultadoQuestao({ respostas, avaliacoes, classes }) {
    if (respostas.length === 0) return 'Nenhuma questão encontrada';
    if (!imprimeResposta(respostas)) return null;

    return (
        <Fragment>
            <TableRow className={classes.tituloQuestao}>
                <TableCell colSpan={respostas.length}>
                    <Typography variant="h3" className={classes.label} >{ respostas[0].titulo }</Typography>
                </TableCell>
            </TableRow>
            { renderizarRespostas(respostas, avaliacoes) }
        </Fragment>
    );
}

ResultadoQuestao.propTypes = {
    /** Dados das respostas a serem exibidas  */
    respostas: PropTypes.arrayOf(PropTypes.instanceOf(AvaliacaoResposta)).isRequired,
    /** Dados das avaliações a serem exibidas  */
    avaliacoes: PropTypes.arrayOf(PropTypes.instanceOf(Avaliacao)).isRequired,
    /** Estilos do componente */
    classes: PropTypes.object
};

export default withStyles(ResultadoStyle)(ResultadoQuestao);